import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { VotingPeriod } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-pap-period',
  templateUrl: 'pap-period.component.html',
  styleUrls: ['./pap-period.component.less', '../../../shared/common.less'],
})

export class PapPeriodComponent implements OnInit {
  @Input() period: VotingPeriod;
  @Output() periodChange = new EventEmitter<VotingPeriod>();

  needPap: boolean = undefined;
  minDate: string;

  constructor(
    private router: Router,
  ) {
    const today = new Date();
    this.minDate = today.toISOString().substring(0, 10);
  }

  get minFirstClosingDate(): string {
    return this.fROpeningString || this.minDate;
  }

  get minSecondClosingDate(): string {
    return this.sROpeningString || this.minDate;
  }

  get minSecondOpeningDate(): string {
    return this.fRClosingString || this.minDate;
  }

  /**
    *
    * Getter and setters for first round opening date
    *
    */
  get fROpeningString(): string {
    return this.period.fROpening && (this.period.fROpening instanceof Date)
      ? this.period.fROpening.toISOString().substring(0, 10)
      : '';
  }

  set fROpeningString(value: string) {
    this.period.fROpening = value ? new Date(value) : null;

    if (this.period.fROpening && this.period.fRClosing && this.period.fRClosing < this.period.fROpening) {
      this.period.fRClosing = new Date(this.period.fROpening);
    }
  }

  get fROpeningTime(): string {
    if (!this.period.fROpening) return '';

    const hours = this.period.fROpening.getHours().toString().padStart(2, '0');
    const minutes = this.period.fROpening.getMinutes().toString().padStart(2, '0');

    return `${hours}:${minutes}`;
  }

  set fROpeningTime(value: string) {
    if (!this.period.fROpening) {
      this.period.fROpening = new Date();
    }

    const [hours, minutes] = value.split(':').map(Number);
    this.period.fROpening.setHours(hours, minutes, 0, 0);
  }

  /**
   *
   * Getter and setters for first closing date
   *
   */
  get fRClosingString(): string {
    return this.period.fRClosing && (this.period.fRClosing instanceof Date)
      ? this.period.fRClosing.toISOString().substring(0, 10)
      : '';
  }

  set fRClosingString(value: string) {
    this.period.fRClosing = value ? new Date(value) : null;
  }

  get fRClosingTime(): string {
    if (!this.period.fRClosing) return '';

    const hours = this.period.fRClosing.getHours().toString().padStart(2, '0');
    const minutes = this.period.fRClosing.getMinutes().toString().padStart(2, '0');

    return `${hours}:${minutes}`;
  }

  set fRClosingTime(value: string) {
    if (!this.period.fRClosing) {
      this.period.fRClosing = new Date();
    }

    const [hours, minutes] = value.split(':').map(Number);
    this.period.fRClosing.setHours(hours, minutes, 0, 0);
  }

  /**
    *
    * Getter and setters for first round opening date
    *
    */
  get sROpeningString(): string {
    return this.period.sROpening  && (this.period.sROpening instanceof Date)
      ? this.period.sROpening.toISOString().substring(0, 10)
      : '';
  }

  set sROpeningString(value: string) {
    this.period.sROpening = value ? new Date(value) : null;

    // Si la date de clôture existe et est antérieure à la nouvelle date d'ouverture, l'ajuster
    if (this.period.sROpening && this.period.sRClosing && this.period.sRClosing < this.period.sROpening) {
      this.period.sRClosing = new Date(this.period.sROpening);
    }
  }

  get sROpeningTime(): string {
    if (!this.period.sROpening) return '';

    const hours = this.period.sROpening.getHours().toString().padStart(2, '0');
    const minutes = this.period.sROpening.getMinutes().toString().padStart(2, '0');

    return `${hours}:${minutes}`;
  }

  set sROpeningTime(value: string) {
    if (!this.period.sROpening) {
      this.period.sROpening = new Date();
    }

    const [hours, minutes] = value.split(':').map(Number);
    this.period.sROpening.setHours(hours, minutes, 0, 0);
  }

  /**
   *
   * Getter and setters for first closing date
   *
   */
  get sRClosingString(): string {
    return this.period.sRClosing && (this.period.sRClosing instanceof Date)
      ? this.period.sRClosing.toISOString().substring(0, 10)
      : '';
  }

  set sRClosingString(value: string) {
    this.period.sRClosing = value ? new Date(value) : null;
  }

  get sRClosingTime(): string {
    if (!this.period.sRClosing) return '';

    const hours = this.period.sRClosing.getHours().toString().padStart(2, '0');
    const minutes = this.period.sRClosing.getMinutes().toString().padStart(2, '0');

    return `${hours}:${minutes}`;
  }

  set sRClosingTime(value: string) {
    if (!this.period.sRClosing) {
      this.period.sRClosing = new Date();
    }

    const [hours, minutes] = value.split(':').map(Number);
    this.period.sRClosing.setHours(hours, minutes, 0, 0);
  }

  onPeriodChange() {
    this.periodChange.emit(this.period);
  }

  goToPollCreation() {
    this.router.navigate(['/poll-creation']);
  }

  ngOnChanges(): void {

  }

  ngOnInit(): void {
  }
}
